<template>
	<div style="background-color: #EFEFEF;">

		<!-- 空白展位 -->
		<div style="padding: .25rem 0;"></div>

		
		<div class="order-div"  v-if="addressInfo.address_id == 0" style="text-align: center; " >
			<div>
				<span style="font-size: .6rem;color: #000000;" @click="pageTo('/user/address')">点击添加收货地址</span>
			</div>
		</div>
		<div class="order-div" v-if="addressInfo.address_id > 0">
			<div style="height: 0.8rem;font-size: .5rem;color: #000000;">
				<span style="">收货地址</span>
				<span style="float: right;"  @click="pageTo('/user/address')">修改地址</span>
			</div>
			<div style="height: 0.8rem;">
				<span style="font-size: .4rem;color: #000000;">{{addressInfo.name}},{{addressInfo.phone}}</span>
			</div>
			<div>
				<span style="font-size: .4rem;color: #000000;">{{addressInfo.area}},{{addressInfo.dizhi}}</span>
			</div>
		</div>

		<!-- 空白展位 -->
		<div class="" style="padding: .25rem 0;"></div>

		<div class="order-div" style="color: #101010;">
			<div>
				<span style="font-size: .5rem;color: #000000;">商品清单</span>
			</div>

			<div class="goods-list" v-for="goods of goodsInfo" :key="goods.goods_id">
				<img :src="goods.goods_image" style="display: block; width: 2rem;float: left;border-radius: 0.2rem;" />
				<div style="padding-left: 1rem;width: 8rem; font-size: 0.5rem;height: 2rem;float: left;">
					<span style="">{{goods.goods_name}}</span>
				</div>
				<div style="margin-left: 0.5rem; width: 3rem; font-size: 0.5rem;height: 2rem;float: right;text-align: right;">
					<span>￥{{goods.goods_price}}</span><br>
					<span>x{{goods.goods_num}}</span>
				</div>
			</div>

			<div style="font-size: 0.5rem; padding-top: 0.5rem;">
				<span style="width: 2rem;">价格明细 </span>
				<span style="float: right;">折扣 ￥0.00</span>
			</div>
			<div style="font-size: 0.5rem; padding-top: 0.5rem; text-align: right;">
				<span>共{{count.num}}件商品 总计</span>
				<span style="color: #ff9d8f;">￥{{count.sum}}</span>
			</div>

		</div>

		<!-- 空白展位 -->
		<div class="" style="padding: .25rem 0;"></div>

		<div class="order-div" style="font-size: 0.5rem;height: 1.5rem;line-height: 1.5rem;">
			<span>买家留言</span>
			<span style="margin-left: 2rem;color: #101010;">50字以内(选填)</span>
		</div>

		<!-- 空白展位 -->
		<div class="" style="padding: .25rem 0;"></div>

		<div class="order-div" style="font-size: 0.5rem;">
			<div style="padding: 0.3rem 0;">
				<span>商品小计</span>
				<span style="float: right;">￥{{count.sum}}</span>
			</div>
			<div class="cut-line">
				<span>运费</span>
				<span style="float: right;">￥0.00</span>
			</div>
		</div>

		<!-- 空白展位 -->
		<div class="" style="padding: .25rem 0;"></div>

		<br />
		<br />
		<br />

		<div class='order-bottom'>
			<div class='order-payment' @click="addOrder">立即支付</div>
			<div class='order-paytext'>实付款: <span style="color: #ff9d8f;">￥{{count.sum}}</span></div>
		</div>

		<!-- 组件使用 -->
		<syalert ref="syalert_id" />

	</div>
</template>
<style>
	.cut-line {
		margin: 0.3rem 0;
		padding-top: 0.3rem;
		border-top: 1px solid #EFEFEF;
	}

	.order-div {
		width: 90%;

		background-color: #FFFFFF;
		padding: .5rem 0;

		padding-left: .5rem;
		padding-right: .5rem;

		margin: 0 auto;

		border-radius: .5rem;
	}

	.goods-list
	{
		height: 2rem;
		margin-top: .5rem;
	}


	.order-bottom {
		width: 100%;
		height: 3rem;

		position: fixed;
		bottom: 0px;

		/* border: 1px solid blue; */
		background-color: #ffffff;
	}

	.order-paytext {
		float: right;

		margin: 0.5rem 0;

		font-size: .7rem;
		color: black;
		text-align: center;

		height: 2rem;
		width: 6rem;

		line-height: 2rem;
	}

	.order-payment {
		float: right;

		margin: 0.5rem 0.5rem;

		font-size: .7rem;
		color: white;
		text-align: center;

		height: 2rem;
		width: 6rem;
		border-radius: 2rem;

		line-height: 2rem;

		background-color: #d9001b;
	}
</style>
<script>
	// 组件引入
	import sy from "@/sy";

	import syalert from '@/components/syalert.vue';
	// import foot from '@/components/foot.vue';

	export default {
		name: 'submit',
		components: {
			syalert,
		},
		data() {
			return {
				addressInfo: {},
				goodsInfo: [],
				gid: 0,
				ids: 0,
				count:
				{
					num: 0,
					sum: 0,
				},
			}
		},
		methods:
		{
			pageTo: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},
			addOrder: function()
			{
				// 实例重命名
				let $_this = this;
				sy.http.get(
				{
					url: this.$root.API + 'Order/Add',
					data: {
						'gid': this.gid,
						'ids': this.ids,
					},
					success: function(res)
					{
						if( res.state === '0' )
						{
							return $_this.$refs.syalert_id.syalert(res.msg);
						}


						$_this.$router.push('/order/payment?oid=' + res.data.order_id + '&fee=' + res.data.order_fee );

						// console.log(res.data);
						// $_this.goodsInfo = res.data;
						// $_this.photo_list = res.data.image_list;
						// for(let x of res.data.image_list )
						// {
						// 	$_this.sliderList.push( {image: x.image_link} );
						// }
					}
				});
			},
			getPreview: function()
			{
				// ----- ----- 实例重命名
				let $_this = this;
				sy.http.get(
				{
					url: this.$root.API + 'Order/Preview',
					data: {
						'gid': this.gid,
						'ids': this.ids,
					},
					success: function(res)
					{
						if( res.state === '0' )
						{
							return $_this.$refs.syalert_id.syalert(res.msg);
						}

						$_this.goodsInfo = res.data;

						// console.log(res.data);
						let num = 0;
						let sum = 0;
						for(let x of res.data)
						{
							num++;
							sum += parseFloat(x.goods_price) * x.goods_num;
						}
						$_this.count.num = num;
						$_this.count.sum = sum.toFixed(2);
					}
				});
			},
			getAddress: function()
			{
				// ----- ----- 实例重命名
				let $_this = this;
				sy.http.get(
				{
					url: this.$root.API + 'Address/Get',
					data: { 
					},
					success: function(res)
					{
						if( res.state === '0' )
						{
							return $_this.$refs.syalert_id.syalert(res.msg);
						}

						$_this.addressInfo = res.data;
					}
				});
			},
			
			

		},
		created() {
			this.ids = this.$router.currentRoute.query.ids;
			this.gid = this.$router.currentRoute.query.gid;
			console.log(this.ids);
			console.log(this.gid);
			if( this.ids !== undefined )
			{
				console.log('购物车流程');
			}
			if( this.gid !== undefined )
			{
				console.log('商品页流程');
			}

			// 实际哪个过来对我们有什么影响吗 方便判断而已
			this.getPreview();
			this.getAddress();

		},
	}
</script>